import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from "react";
import { useSetItemsCompleted } from "@sprout/client-graphql";
import { PostPageDescriptionEditor } from "../PostPageEditors";
import { usePostPage } from "../PostPageContext";
import PostPagePostCompleted from "./PostPagePostCompleted";
const PostPagePost = (props)=>{
    const { post  } = props;
    const { description , id , completed , nodeId  } = post;
    const { disabled  } = usePostPage();
    const setItemsCompleted = useSetItemsCompleted();
    const handleChange = useCallback(()=>{
        setItemsCompleted({
            items: [
                post
            ],
            completed: !post.completed
        });
    }, [
        post,
        setItemsCompleted
    ]);
    return /*#__PURE__*/ _jsx(PostPageDescriptionEditor, {
        description: description,
        itemId: id,
        children: /*#__PURE__*/ _jsx(PostPagePostCompleted, {
            completed: completed,
            id: nodeId,
            disabled: disabled,
            onChange: handleChange
        })
    });
};
export default PostPagePost;
